export function getIconProps(props) {
    return props.icon && (props.size === 'xs' ? { name: props.icon, size: 'xs' } : { name: props.icon, size: 'm' });
}
//# sourceMappingURL=utils.js.map